<template>
    <MainPage :showTopTitle="true" @clickBack="clickBack()">
        <div class="max-w-2xl m-auto p-4">
            <div class="rounded-14 border border-a-brown-d7c7b8">
                <div class="">
                    <HistoryTab></HistoryTab>
                </div>
                <div>
                    <HistoryList v-if="isHistoryRedeem" ref="history-list"></HistoryList>
                    <HistoryPoint v-if="isHistoryPoint"></HistoryPoint>
                    <PointExpire v-if="isExpirePoint"></PointExpire>
                </div>
            </div>
        </div>
    </MainPage>
</template>
<script>
import Util from '@/helper/Utility.js';
//component
import MainPage from '@/components/Layout/Page/MainPage.vue';
import HistoryList from '../component/HistoryRedeem/HistoryList.vue';
import HistoryTab from '../component/HistoryTab/HistoryTab.vue';
import HistoryPoint from '../component/HistoryPoint/HistoryPoint.vue';
import PointExpire from '../component/PointExpire/PointExpire.vue';
//mixin
import AuthStatusMixin from '@/mixin/AuthStatusMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';

export default {
    name: 'History',
    mixins: [ModalMixin, AuthStatusMixin],
    components: {
        MainPage,
        HistoryList,
        HistoryTab,
        HistoryPoint,
        PointExpire,
    },
    data: function() {
        return {
            purchaseListConfig: null,
            purchaseFilterListConfig: null,

            historyTabActive: '', // point, redeem, expire
        };
    },
    computed: {
        isHistoryRedeem: function() {
            return this.historyTabActive == 'redeem';
        },
        isHistoryPoint: function() {
            return this.historyTabActive == 'point';
        },
        isExpirePoint: function () {
            return this.historyTabActive == 'expire';
        },
    },
    created: function () {
        this.tracking.screenName('point History');

        let tabParams = this.$route.params.tab;
        if (Util.isEmptyStr(tabParams)) {
            tabParams = 'point';
        }
        this.historyTabActive = tabParams;

        this.setScrollLoadMore();
        // this.setupHistoryList();
    },
    mounted: async function () {
        Util.scrollTop();
        // this.modal.loadingModal.show();
        // if (this.isHistoryRedeem) {
        //     await this.$refs['history-list'].getList();
        // }
        // this.modal.loadingModal.hide();
    },
    beforeUnmount: function() {
        window.onscroll = null;
    },
    methods: {
        clickBack: function () {
            this.$router.back();
        },

        setScrollLoadMore: function() {
            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow) {
                    this.loadMore();
                }
            };
        },

        loadMore: async function() {
            this.modal.loadingModal.show();
            if (this.isHistoryRedeem) {
                await this.$refs['history-list'].loadMore();
            }
            this.modal.loadingModal.hide();
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
